import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h6 } from '@helpers/typography';
import { staggerChildren, verticalFadeIn } from '@helpers/variants';
import { DownloadCardStyles } from '@stories/Components/Cards/DownloadCard/DownloadCard.styles';
import SectionTitleStyles from '@stories/Components/Global/SectionTitle/SectionTitle.styles';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div).attrs((inView) => ({
    initial: 'hidden',
    animate: inView ? 'visible' : 'hidden',
})) `
  overflow: hidden;

  &[data-thin-layout='true'] {
    ${SectionWrapperStyles.SiteWide} {
      padding: 0;
    }

    ${SectionTitleStyles.Title} {
      ${h6};
      color: ${brand.black};
      background: transparent;
      -webkit-background-clip: unset;
      -webkit-text-fill-color: unset;
    }
  }
`;
const CardsGrid = styled(m.div).attrs(() => ({
    variants: staggerChildren(0.15),
})) `
  display: grid;
  grid-template-columns: 1fr;
  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(3, 1fr);
  }
  gap: ${fluidAdjusted(16, 48, Device.Mobile, Device.ActualDesktop)};
`;
const DownloadsCarousel = styled.div ``;
const PaddedContainer = styled.div `
  padding-right: 15px;
  flex: 0 0 100%;

  @media ${from(Device.TabletLarge)} {
    flex: 0 0 33.3%;
  }

  ${() => DownloadCardStyles.Container} {
    height: 100%;
  }

  [data-thin-layout='true'] & {
    flex: 0 0 100%;
  }
`;
const Pagination = styled.div `
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  padding: 15px 0px;
`;
const ListPagination = styled.div `
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  align-items: center;
  margin-top: 32px;
`;
const ShowingWrapper = styled.div `
  display: flex;
  gap: 5px;
  font-size: 20px;

  span {
    font-weight: 900;
  }
`;
const ProgressBar = styled.div `
  width: 50%;
  margin: auto;
  background-color: ${brand.grey.grey90};
  height: 10px;
  position: relative;
  border-radius: 100px;
  overflow: hidden;
  margin: 15px 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: ${brand.black};
    width: ${({ progress }) => `${progress}%`};
    border-radius: 0px 100px 100px 0;
    transition: width 0.25s ease-in-out;
  }
`;
const CardMotionWrapper = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(25),
})) `
  display: flex;
`;
const PublicationsTitle = styled.div `
  ${h6};
  font-size: ${fluidAdjusted(18, 24)};
  line-height: ${fluidAdjusted(22, 30)};
`;
export const DownloadCardsStyles = {
    Container,
    CardsGrid,
    DownloadsCarousel,
    PaddedContainer,
    Pagination,
    ListPagination,
    ShowingWrapper,
    ProgressBar,
    CardMotionWrapper,
    PublicationsTitle,
};
